module.exports = __webpack_public_path__ + "../resources/images/strikethrough-9549f019f8e3ecfdabd7e11ac4fd7c9b.svg";